"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoResults = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function NoResults() {
    return (react_1.default.createElement("div", { style: {
            height: 300,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        } },
        react_1.default.createElement(core_ui_1.Text, { size: "large" }, "No results")));
}
exports.NoResults = NoResults;
